import { render, staticRenderFns } from "./queue-management.vue?vue&type=template&id=17a87d5c&scoped=true&"
import script from "./queue-management.vue?vue&type=script&lang=js&"
export * from "./queue-management.vue?vue&type=script&lang=js&"
import style0 from "./queue-management.vue?vue&type=style&index=0&id=17a87d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a87d5c",
  null
  
)

export default component.exports